import { ReactNode } from 'react';
import Header from './Header';
import Footer from './Footer';
import FloatingSupport from '@/components/FloatingSupport';

interface LayoutProps {
  children: ReactNode;
  showAiSupport?: boolean;
}

const Layout = ({ children, showAiSupport = false }: LayoutProps) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 pt-[88px] lg:pt-[100px]">
        {children}
      </main>
      <Footer />
      <FloatingSupport showAi={showAiSupport} />
    </div>
  );
};

export default Layout;
